import { useI18n } from "../../shared/i18n";
import { Icon } from "../../shared/ui/icons";
import { useState } from "react";

import { useSession } from "../auth/session";

export function DashboardPage() {
  const { session } = useSession();
  // Same reason as the rail: these tiles are full-page navigations.
  const [leaving, setLeaving] = useState(false);
  const { t, lang } = useI18n();
  const modules = (session?.modules ?? []).filter((m) => m.base_path !== "/");
  const roles = session?.roles ?? [];

  const label = (m: { name: string; name_ar: string }) =>
    lang === "ar" && m.name_ar ? m.name_ar : m.name;

  // In Arabic a name splits the same way, but there is no reliable "first name" for
  // every naming convention, so the whole name is used when there is only one part.
  const firstName = session?.user.full_name.trim().split(/\s+/)[0] ?? "";

  return (
    <div className="stack">
      {leaving && <div className="nav-progress" role="progressbar" aria-label={t("nav.loading")} />}
      <section className="card">
        <h2>{t("dash.welcome", { name: firstName })}</h2>
        <p className="muted">
          {t("dash.signedInAs", { email: session?.user.email ?? "" })}{" "}
          {roles.length === 1
            ? t("dash.roleOne", { roles: roles.join(", ") })
            : t("dash.roleMany", { roles: roles.join(", ") || "—" })}
        </p>
        {session?.user.must_change_password && (
          // Shown, not enforced here. Enforcing is the API's job; a banner the user
          // can read and act on is the frontend's.
          <p className="banner warn" role="alert" style={{ marginBlockStart: "var(--s-4)" }}>
            {t("dash.mustChange")}
          </p>
        )}
      </section>

      <section>
        <h2 className="section-title">{t("dash.yourModules")}</h2>
        <div className="tiles" style={{ marginBlockStart: "var(--s-3)" }}>
          {modules.map((m) => (
            <a key={m.key} href={m.base_path} className="tile" onClick={() => setLeaving(true)}>
              <span className="tile-icon">
                <Icon name={m.icon} size={22} />
              </span>
              <span className="tile-name">{label(m)}</span>
              {/* The other language's name as a subtitle: the invoices these modules
                  handle are bilingual, so both names are worth showing. */}
              <span className="tile-sub">{lang === "ar" ? m.name : m.name_ar}</span>
            </a>
          ))}
          {modules.length === 0 && <p className="muted">{t("dash.noModules")}</p>}
        </div>
      </section>

      <section className="card">
        <h2>{t("dash.permissions")}</h2>
        <p className="muted small" style={{ marginBlockStart: "var(--s-1)" }}>
          {t("dash.permissionsHelp")}
        </p>
        <ul className="perm-list">
          {session?.permissions.map((p) => (
            <li key={p}>
              <code>{p}</code>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
